/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BulkUpdateEquipmentWorkerRequest } from './bulk-update-equipment-worker-request';
import { BulkUpdateEquipmentModeRequest } from './bulk-update-equipment-mode-request';


export interface BulkUpdateEquipmentRequest { 
    equipmentIds?: Array<string> | null;
    mode?: BulkUpdateEquipmentModeRequest;
    workers?: Array<BulkUpdateEquipmentWorkerRequest> | null;
}

